import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate,DownloadFile } from './Function';
import { usePage } from '../PageContext';
import { Card,Table,Placeholder } from 'react-bootstrap';
const ExamsDetails = ({htaccess}) => 
{
    const { currentPage } = usePage();
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const[isLoading, setLoading] = useState(true);
    const[Exams,setExams]=useState([]);
    useEffect(()=>
    {
        const ExamsDetails = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"exams/details/"+htaccess);
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.se_id + "/examFile")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.se_id + "/examFileHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].examFile = el.upp;
                            result[i].examFileHi = el.upb;
                        });
                        setExams(result[0]);
                        currentPage(result[0]);
                        setLoading(false);
                    }).catch(error => {
                        console.error('ExamsDetails File :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setExams([]);
                    setLoading(false);            
                }
                if( global.config.IsPrint === true ) { console.info('ExamsDetails : Result',result); }
            } catch (error)
            {
                console.error('ExamsDetails : Error', error.message);
                setLoading(false);
            }
        };        
        ExamsDetails();
        // eslint-disable-next-line
    },[htaccess])
    return (
        <Card>
            <Card.Header className='text-center fs-3 text-uppercase'>
                {t('ExamDetails')}
            </Card.Header>
            <Card.Body>                    
                {isLoading ? (
                <Table responsive bordered className='mb-0'>
                <tbody>
                    {[...Array(5)].map((_,index)=>(
                    <tr key={index}>
                        <th className="table-success w-25"><Placeholder xs={10} /></th>
                        <td className="text-center"><Placeholder xs={10} /></td>
                    </tr>
                    ))}
                </tbody>
                </Table>
                ) : (
                <React.Fragment>
                {Exams.se_id > 0 ? (
                <Table responsive bordered className='mb-0'>
                <tbody>                                     
                    <tr>
                        <th className="table-success w-25 text-end">{t('Title')}:</th>
                        <th dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (Exams.se_display_en === "1" ? Exams.se_name_hi || '' : Exams.se_name_hi || Exams.se_name) : Exams.se_name }}></th>
                    </tr>
                    <tr>
                        <th className="table-success w-25 text-end">{t('Content')}:</th>
                        <th dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (Exams.se_display_en === "1" ? Exams.se_description_hi || '' : Exams.se_description_hi || Exams.se_description) : Exams.se_description }}></th>
                    </tr>
                    <tr>
                        <th className="table-success w-25 text-end">{t('Type')}:</th>
                        <th dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? ( Exams.examType.et_name_hi ? Exams.examType.et_name_hi : Exams.examType.et_name ) : Exams.examType.et_name }}></th>
                    </tr>
                    <tr>
                        <th className="table-success w-25 text-end">{t('Download')}:</th>
                        <td dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,Exams.examFile,Exams.examFileHi)}} />                            
                    </tr>                      
                    <tr>
                        <th className="table-success w-25 text-end">{t('UploadDate')}:</th>
                        <td>{formatDate(Exams.se_date)}</td>
                    </tr>                                    
                </tbody>
                </Table>
                ) : (
                <div className='text-center lead fw-bold'>
                    {appLanguage === 'hi' ? 'हम वह परीक्षा नहीं ढूंढ पाए जिसका विवरण हम आपको दिखाना चाहते थे।' : "We can't find the exam whose details we wanted to show you."}
                </div>
                )}
                </React.Fragment>                        
                )}                    
            </Card.Body>
        </Card>
    );
}
export default ExamsDetails;